<div>
  <app-loader *ngIf="(coursesLoading$ | async) === true"></app-loader>
  <form
    *ngIf="(coursesLoading$ | async) === false && groups$.length > 0"
    [formGroup]="holidayForm"
    (ngSubmit)="onSubmit()">
    <mat-dialog-content>
      <mat-form-field
        appearance="outline"
        class="mb-3"
        (click)="start_date_picker.open()">
        <mat-label>Дата начала</mat-label>
        <input
          readonly
          required
          [errorStateMatcher]="matcher"
          matInput
          [matDatepicker]="start_date_picker"
          formControlName="offset_date" />
        <mat-hint>ДД.ММ.ГГГГ</mat-hint>
        <mat-datepicker-toggle
          matSuffix
          [for]="start_date_picker"></mat-datepicker-toggle>
        <mat-datepicker #start_date_picker></mat-datepicker>
        <mat-error *ngIf="offsetDate!.errors?.required">
          {{ requiredErrorMessage }}
        </mat-error>
        <mat-error>{{ getMessageFormError('offset_date') }}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="pb-4 pb-sm-2">
        <mat-label>Количество недель</mat-label>
        <input
          required
          matInput
          type="number"
          min="1"
          [errorStateMatcher]="matcher"
          formControlName="weeks_offset" />
        <mat-error *ngIf="offsetWeeks!.errors?.required">
          {{ requiredErrorMessage }}
        </mat-error>
        <mat-error>{{ getMessageFormError('weeks_offset') }}</mat-error>
      </mat-form-field>

      <div>
        <p><b>Выберите группы:</b></p>
        <mat-checkbox
          (change)="toggleAllSelectGroups($event)"
          [checked]="updateAllSelected()"
          [indeterminate]="someSelected()"
          color="primary"
          labelPosition="before"
          class="text-center select-all-checkbox">
          Выбрать все. Выбрано:
          {{ selectedGroups.size }}
        </mat-checkbox>
        <mat-selection-list class="groups-list">
          <div>
            <ng-container *ngFor="let group of groups$">
              <mat-list-option
                (click)="toggleSelectGroups(group.id)"
                [selected]="isSelectGroup(group.id)"
                [value]="group.id"
                color="primary"
                class="text-left">
                <div class="group-name">
                  <p class="mb-0">{{ group.full_name }}</p>
                </div>
              </mat-list-option>
            </ng-container>
          </div>
        </mat-selection-list>
      </div>
    </mat-dialog-content>

    <div mat-dialog-actions class="justify-content-end">
      <button type="button" class="mr-2" mat-raised-button (click)="onCancel()">
        Отмена
      </button>

      <app-button-with-progress
        typeBtn="submit"
        (click)="onSubmit()"
        [loading$]="sendLoading$ | async"
        label="Добавить"></app-button-with-progress>
    </div>
  </form>

  <ng-container
    *ngIf="(coursesLoading$ | async) === false && groups$.length === 0">
    <mat-dialog-content>
      <p>Список активных групп пуст.</p>
      <button type="button" class="mr-2" mat-raised-button (click)="onCancel()">
        Закрыть
      </button>
    </mat-dialog-content>
  </ng-container>
</div>
